import React from 'react';

import { Container } from './Row.styles';

import { ResponsiveValue } from '../../types';
import { ColumnProps } from '../Column/Column';

export type RowProps = {
  /**
   * React children nodes
   */
  children: React.ReactNode;
  /**
   * Row gutter
   */
  gutter?: ResponsiveValue;
  /**
   * Row gap
   */
  rowGap?: ResponsiveValue;
};

const Row = ({ children, gutter = '5', rowGap = '5', ...rest }: RowProps) => {
  const columns = gutter
    ? React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child as React.ReactElement<ColumnProps>, {
            gutter,
          });
        }
        return child;
      })
    : children;

  return (
    <Container role="row" gutter={gutter} rowGap={rowGap} {...rest}>
      {columns}
    </Container>
  );
};

export default Row;
